import { ADDRESS_COUNTRIES_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { ICountryModel } from "./address.models";
export const getCountriesAPI = async () => {
  return await apiClient.getHttp<ICountryModel[]>(
    `${ADDRESS_COUNTRIES_API}`,
    undefined,
    false
  );
};